#import "../fragments/inbox-message-fragment.graphql"

mutation SendChatMessage($input: MessageSendForChatInput!) {
    messageSendForChat(input: $input) {
        message {
            ...InboxMessageFragment
        }
    }
}
